<template>
  <div class="pt-5 pb-5 border-t border-custom-grey-7">
    <h2 class="text-lg font-semibold text-custom-text mb-4">
      {{ t("select_payment_method") }}
    </h2>
    <fieldset>
      <legend class="sr-only">{{ t("payment_method") }}</legend>
      <div
        class="rounded-xl border border-gray-200 bg-white overflow-hidden divide-y divide-gray-200"
        role="radiogroup"
        :aria-label="t('payment_method')"
      >
        <!-- Vipps -->
        <div v-if="showVipps">
          <label
            class="flex items-center gap-3 sm:gap-4 px-4 sm:px-5 py-4 sm:py-5 cursor-pointer transition-colors duration-150"
            :class="
              modelValue === 'vipps' ? 'bg-primary/5' : 'hover:bg-gray-50'
            "
          >
            <span
              class="flex-none flex items-center justify-center w-5 h-5 rounded-full border-2 transition-colors duration-200"
              :class="
                modelValue === 'vipps' ? 'border-primary' : 'border-gray-300'
              "
              aria-hidden="true"
            >
              <span
                v-if="modelValue === 'vipps'"
                class="block w-2.5 h-2.5 rounded-full bg-primary"
              />
            </span>
            <img
              :src="vippsIcon"
              width="64"
              class="flex-none object-contain h-7 sm:h-8"
              alt=""
              aria-hidden="true"
            />
            <span
              class="flex-1 text-right font-medium text-custom-text text-sm sm:text-base"
            >
              {{ t("vipps") }}
            </span>
            <input
              type="radio"
              :value="'vipps'"
              :checked="modelValue === 'vipps'"
              name="payment-gateway"
              class="sr-only"
              :aria-label="t('vipps')"
              @change="$emit('update:modelValue', 'vipps')"
            />
          </label>

          <div v-if="modelValue === 'vipps'" class="px-4 sm:px-5 pb-4">
            <p class="text-sm text-custom-grey-1 pl-8 sm:pl-9">
              {{ t("vipps_redirect_notice") }}
            </p>
          </div>
        </div>

        <!-- Manual / Invoice -->
        <div v-if="showManual">
          <label
            class="flex items-center gap-3 sm:gap-4 px-4 sm:px-5 py-4 sm:py-5 cursor-pointer transition-colors duration-150"
            :class="
              modelValue === 'manual' ? 'bg-primary/5' : 'hover:bg-gray-50'
            "
          >
            <span
              class="flex-none flex items-center justify-center w-5 h-5 rounded-full border-2 transition-colors duration-200"
              :class="
                modelValue === 'manual' ? 'border-primary' : 'border-gray-300'
              "
              aria-hidden="true"
            >
              <span
                v-if="modelValue === 'manual'"
                class="block w-2.5 h-2.5 rounded-full bg-primary"
              />
            </span>
            <img
              :src="invoiceIcon"
              width="28"
              class="flex-none object-contain h-7 sm:h-8"
              alt=""
              aria-hidden="true"
            />
            <span
              class="flex-1 text-right font-medium text-custom-text text-sm sm:text-base"
            >
              {{ t("invoice") }}
            </span>
            <input
              type="radio"
              :value="'manual'"
              :checked="modelValue === 'manual'"
              name="payment-gateway"
              class="sr-only"
              :aria-label="t('invoice')"
              @change="$emit('update:modelValue', 'manual')"
            />
          </label>

          <div v-if="modelValue === 'manual'" class="px-4 sm:px-5 pb-4">
            <p class="text-sm text-custom-grey-1 pl-8 sm:pl-9">
              {{ t("pay_with_invoice") }}
            </p>
          </div>
        </div>

        <!-- PayPal -->
        <div v-if="showPaypal">
          <label
            class="flex items-center gap-3 sm:gap-4 px-4 sm:px-5 py-4 sm:py-5 cursor-pointer transition-colors duration-150"
            :class="
              modelValue === 'paypal' ? 'bg-primary/5' : 'hover:bg-gray-50'
            "
          >
            <span
              class="flex-none flex items-center justify-center w-5 h-5 rounded-full border-2 transition-colors duration-200"
              :class="
                modelValue === 'paypal' ? 'border-primary' : 'border-gray-300'
              "
              aria-hidden="true"
            >
              <span
                v-if="modelValue === 'paypal'"
                class="block w-2.5 h-2.5 rounded-full bg-primary"
              />
            </span>
            <img
              :src="paypalIcon"
              width="64"
              class="flex-none object-contain h-7 sm:h-8"
              alt=""
              aria-hidden="true"
            />
            <span
              class="flex-1 text-right font-medium text-custom-text text-sm sm:text-base"
            >
              {{ t("paypal") }}
            </span>
            <input
              type="radio"
              :value="'paypal'"
              :checked="modelValue === 'paypal'"
              name="payment-gateway"
              class="sr-only"
              :aria-label="t('paypal')"
              @change="$emit('update:modelValue', 'paypal')"
            />
          </label>

          <div v-if="modelValue === 'paypal'" class="px-4 sm:px-5 pb-4">
            <p class="text-sm text-custom-grey-1 pl-8 sm:pl-9">
              {{ t("paypal_redirect_notice") }}
            </p>
          </div>
        </div>

        <!-- Kustom -->
        <div v-if="showKustom">
          <label
            class="flex items-center gap-3 sm:gap-4 px-4 sm:px-5 py-4 sm:py-5 cursor-pointer transition-colors duration-150"
            :class="
              modelValue === 'kustom' ? 'bg-primary/5' : 'hover:bg-gray-50'
            "
          >
            <span
              class="flex-none flex items-center justify-center w-5 h-5 rounded-full border-2 transition-colors duration-200"
              :class="
                modelValue === 'kustom' ? 'border-primary' : 'border-gray-300'
              "
              aria-hidden="true"
            >
              <span
                v-if="modelValue === 'kustom'"
                class="block w-2.5 h-2.5 rounded-full bg-primary"
              />
            </span>
            <img
              :src="kustomIcon"
              width="64"
              class="flex-none object-contain h-7 sm:h-8"
              alt="Kustom"
              aria-hidden="true"
            />
            <span
              class="flex-1 text-right font-medium text-custom-text text-sm sm:text-base"
            >
              {{ t("kustom") }}
            </span>
            <input
              type="radio"
              :value="'kustom'"
              :checked="modelValue === 'kustom'"
              name="payment-gateway"
              class="sr-only"
              :aria-label="t('kustom')"
              @change="$emit('update:modelValue', 'kustom')"
            />
          </label>

          <div v-if="modelValue === 'kustom'" class="px-4 sm:px-5 pb-4">
            <p class="text-sm text-custom-grey-1 pl-8 sm:pl-9">
              {{ t("kustom_redirect_notice") }}
            </p>
          </div>
        </div>

        <!-- Stripe / Credit Card -->
        <div v-if="showStripe">
          <label
            class="flex items-center gap-3 sm:gap-4 px-4 sm:px-5 py-4 sm:py-5 cursor-pointer transition-colors duration-150"
            :class="
              modelValue === 'stripe' ? 'bg-primary/5' : 'hover:bg-gray-50'
            "
          >
            <span
              class="flex-none flex items-center justify-center w-5 h-5 rounded-full border-2 transition-colors duration-200"
              :class="
                modelValue === 'stripe' ? 'border-primary' : 'border-gray-300'
              "
              aria-hidden="true"
            >
              <span
                v-if="modelValue === 'stripe'"
                class="block w-2.5 h-2.5 rounded-full bg-primary"
              />
            </span>
            <CreditCardIcon
              class="flex-none h-7 sm:h-8 w-auto"
              :aria-hidden="true"
            />
            <span
              class="flex-1 text-right font-medium text-custom-text text-sm sm:text-base"
            >
              {{ t("credit_card") }}
            </span>
            <input
              type="radio"
              :value="'stripe'"
              :checked="modelValue === 'stripe'"
              name="payment-gateway"
              class="sr-only"
              :aria-label="t('credit_card')"
              @change="$emit('update:modelValue', 'stripe')"
            />
          </label>

          <!-- Inline card form when stripe is selected -->
          <div v-if="modelValue === 'stripe'" class="px-4 sm:px-5 pb-4">
            <div class="pl-8 sm:pl-9">
              <h4 class="text-sm font-semibold text-custom-grey-1 mb-3">
                {{ t("pay_with_credit_card") }}
              </h4>
              <div v-if="cards && cards.length > 0" class="mb-3">
                <label class="block w-full">
                  <span class="text-custom-text pb-1 text-sm font-semibold">
                    {{ t("select_payment_card") }}
                  </span>
                  <select
                    class="block py-2 pl-3 border border-gray-300 rounded-md cursor-pointer placeholder-gray-500 transition w-full shadow-sm min-h-12 text-custom-text bg-gray-200 bg-opacity-70 focus:bg-white focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50"
                    :value="selectedCardToken"
                    :aria-label="t('select_payment_card')"
                    @change="
                      $emit(
                        'update:selectedCardToken',
                        ($event.target as HTMLSelectElement).value === 'null'
                          ? null
                          : ($event.target as HTMLSelectElement).value
                      )
                    "
                  >
                    <option
                      v-for="card in cards"
                      :value="card.id"
                      :key="card.id"
                    >
                      &bull;&bull;&bull;&bull; {{ card.last4 }}
                      {{ card.brand }} {{ card.exp_month }}/{{ card.exp_year }}
                    </option>
                    <option value="null">
                      {{ t("add_new_card") }}
                    </option>
                  </select>
                </label>
              </div>
              <div v-if="selectedCardToken === null" class="space-y-3">
                <slot name="stripe-card" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import invoiceIcon from "../assets/invoice-icon.png";
import CreditCardIcon from "../assets/CreditCardIcon.vue";
import vippsIcon from "../assets/vipps-icon.png";
import paypalIcon from "../assets/paypal-icon.png";
import kustomIcon from "../assets/kustom-icon.svg";
import type { ICard } from "@/scripts/application/types";

const { t } = useI18n();

defineProps<{
  modelValue: "stripe" | "manual" | "vipps" | "paypal" | "kustom";
  showStripe: boolean;
  showManual: boolean;
  showVipps: boolean;
  showPaypal: boolean;
  showKustom: boolean;
  cards?: ICard[];
  selectedCardToken: string | null | undefined;
}>();

defineEmits<{
  (e: "update:modelValue", value: "stripe" | "manual" | "vipps" | "paypal" | "kustom"): void;
  (e: "update:selectedCardToken", value: string | null): void;
}>();
</script>

<i18n lang="yaml">
en:
  payment_method: Payment method
  select_payment_method: Select payment method
  credit_card: Credit card
  invoice: Invoice / bank transfer
  vipps: Vipps
  paypal: PayPal
  kustom: Kustom
  pay_with_credit_card: Pay with credit card
  pay_with_invoice: You will receive an invoice via email for bank transfer payment.
  pay_with_vipps: Pay with Vipps
  pay_with_paypal: Pay with PayPal
  pay_with_kustom: Pay with Kustom
  vipps_redirect_notice: You will be redirected to Vipps to complete your payment.
  paypal_redirect_notice: You will be redirected to PayPal to complete your payment.
  kustom_redirect_notice: You'll be redirected to Kustom to complete your payment.
  select_payment_card: Select payment card
  add_new_card: Add new credit card
nb:
  payment_method: Betalingsmåte
  select_payment_method: Velg betalingsmåte
  credit_card: Kredittkort
  invoice: Faktura
  vipps: Vipps
  paypal: PayPal
  kustom: Kustom
  pay_with_credit_card: Betal med kredittkort
  pay_with_invoice: Du vil motta en faktura på e-post for bankoverføring.
  pay_with_vipps: Betal med Vipps
  pay_with_paypal: Betal med PayPal
  pay_with_kustom: Betal med Kustom
  vipps_redirect_notice: Du blir videresendt til Vipps for å fullføre betalingen.
  paypal_redirect_notice: Du blir videresendt til PayPal for å fullføre betalingen.
  kustom_redirect_notice: Du blir videresendt til Kustom for å fullføre betalingen.
  select_payment_card: Velg betalingskort
  add_new_card: Legg til nytt kredittkort
uk:
  payment_method: Спосіб оплати
  select_payment_method: Виберіть спосіб оплати
  credit_card: Кредитна картка
  invoice: Рахунок
  vipps: Vipps
  paypal: PayPal
  kustom: Kustom
  pay_with_credit_card: Оплатити кредитною карткою
  pay_with_invoice: Ви отримаєте рахунок на електронну пошту для оплати банківським переказом.
  pay_with_vipps: Оплатити через Vipps
  pay_with_paypal: Оплатити через PayPal
  pay_with_kustom: Сплатити через Kustom
  vipps_redirect_notice: Вас буде перенаправлено до Vipps для завершення оплати.
  paypal_redirect_notice: Вас буде перенаправлено до PayPal для завершення оплати.
  kustom_redirect_notice: Вас буде перенаправлено до Kustom для завершення оплати.
  select_payment_card: Виберіть платіжну картку
  add_new_card: Додати нову кредитну картку
es:
  payment_method: Método de pago
  select_payment_method: Seleccionar método de pago
  credit_card: Tarjeta de crédito
  invoice: Factura
  vipps: Vipps
  paypal: PayPal
  kustom: Kustom
  pay_with_credit_card: Pagar con tarjeta de crédito
  pay_with_invoice: Recibirás una factura por correo electrónico para el pago por transferencia bancaria.
  pay_with_vipps: Pagar con Vipps
  pay_with_paypal: Pagar con PayPal
  pay_with_kustom: Pagar con Kustom
  vipps_redirect_notice: Serás redirigido a Vipps para completar el pago.
  paypal_redirect_notice: Serás redirigido a PayPal para completar el pago.
  kustom_redirect_notice: Serás redirigido a Kustom para completar tu pago.
  select_payment_card: Seleccionar tarjeta de pago
  add_new_card: Agregar nueva tarjeta de crédito
pl:
  payment_method: Sposób płatności
  select_payment_method: Wybierz sposób płatności
  credit_card: Karta kredytowa
  invoice: Faktura
  vipps: Vipps
  paypal: PayPal
  kustom: Kustom
  pay_with_credit_card: Zapłać kartą kredytową
  pay_with_invoice: Otrzymasz fakturę e-mailem do opłacenia przelewem bankowym.
  pay_with_vipps: Zapłać przez Vipps
  pay_with_paypal: Zapłać przez PayPal
  pay_with_kustom: Zapłać przez Kustom
  vipps_redirect_notice: Zostaniesz przekierowany do Vipps, aby dokończyć płatność.
  paypal_redirect_notice: Zostaniesz przekierowany do PayPal, aby dokończyć płatność.
  kustom_redirect_notice: Zostaniesz przekierowany do Kustom w celu dokończenia płatności.
  select_payment_card: Wybierz kartę płatniczą
  add_new_card: Dodaj nową kartę kredytową
</i18n>
